import React, { useEffect } from 'react';
import Header from '../../../Header';
import Footer from '../../../Footer';
import Banner from '../../Banner';
import { Link, useLocation } from 'react-router-dom';

const VeriSorumlusuBasvuru: React.FC = () => {
  const location = useLocation();
  const language = location.pathname.startsWith('/en') ? 'en' : 'tr';
  const lang: 'en' | 'tr' = language;

  const setLanguage = (newLang: 'en' | 'tr') => {
    let newPath = location.pathname;
    if (newLang === 'en' && !newPath.startsWith('/en')) {
      newPath = '/en' + (newPath.startsWith('/tr') ? newPath.slice(3) : newPath);
    } else if (newLang === 'tr' && !newPath.startsWith('/tr')) {
      newPath = '/tr' + (newPath.startsWith('/en') ? newPath.slice(3) : newPath);
    }
    window.location.href = newPath;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumb = (
    <>
      <Link to={`/${lang}`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Ana Sayfa' : 'Home'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <Link to={`/${lang}/about/certification`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Sertifikasyon ve Dökümantasyon' : 'Certification & Documentation'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <Link to={`/${lang}/about/certification/documents`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Dökümantasyon' : 'Documentation'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <span className="text-white font-bold">{lang === 'tr' ? 'Veri Sorumlusuna Başvuru Formu' : 'Data Controller Application Form'}</span>
    </>
  );

  return (
    <div>
      <Header language={lang} setLanguage={setLanguage} />
      <Banner
        title={lang === 'tr' ? 'Veri Sorumlusuna Başvuru Formu' : 'Data Controller Application Form'}
        description={lang === 'tr' ? 'Kişisel verilerle ilgili başvurular için form.' : 'Form for applications regarding personal data.'}
        breadcrumb={breadcrumb}
      />
      <div className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-6">
          {lang === 'tr' ? (
            <div className="space-y-8">
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Başvuru Hakkında</h3>
                <p className="text-gray-700 leading-relaxed">6698 sayılı KVKK'nın 11. maddesi kapsamında kişisel verilerinize ilişkin haklarınızı kullanmak için aşağıdaki yöntemlerden birini tercih ederek başvuruda bulunabilirsiniz. CG Teknoloji, başvurunuzu niteliğine göre en geç 30 gün içinde ücretsiz olarak sonuçlandıracaktır.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Başvuruda Bulunması Gereken Bilgiler</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                  <li>Ad, soyad ve T.C. kimlik numarası</li>
                  <li>Tebligata esas ikamet veya işyeri adresi</li>
                  <li>E-posta adresi ve telefon numarası</li>
                  <li>Talep konusu (erişim, düzeltme, silme, itiraz vb.)</li>
                  <li>Talep gerekçesi ve açıklaması</li>
                </ul>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Başvuru Yöntemleri</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                  <li><strong>E-posta:</strong> info@cgteknoloji.com adresine "KVKK Başvurusu" konusuyla e-posta gönderebilirsiniz.</li>
                  <li><strong>Yazılı Başvuru:</strong> Şirket adresimize ıslak imzalı dilekçeyle başvurabilirsiniz.</li>
                </ul>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Yanıt Süresi ve Ücret</h3>
                <p className="text-gray-700 leading-relaxed">Başvurunuz en geç 30 gün içinde ücretsiz olarak yanıtlanır. Talebin ayrıca bir maliyet gerektirmesi halinde Kişisel Verileri Koruma Kurulu tarafından belirlenen tarifeye göre ücret alınabilir.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Kimlik Doğrulama</h3>
                <p className="text-gray-700 leading-relaxed">CG Teknoloji, başvuru sahibinin kimliğini doğrulama hakkını saklı tutar. Güvenli kimlik doğrulaması için ek belge (nüfus cüzdanı fotokopisi vb.) talep edilebilir.</p>
              </section>
            </div>
          ) : (
            <div className="space-y-8">
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">About the Application</h3>
                <p className="text-gray-700 leading-relaxed">To exercise your rights regarding your personal data under Article 11 of the Personal Data Protection Law No. 6698 (KVKK), you may submit an application using one of the methods below. CG Teknoloji will conclude your application free of charge within a maximum of 30 days, depending on its nature.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Information Required in the Application</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                  <li>Name, surname, and Turkish ID number</li>
                  <li>Residential or business address for notifications</li>
                  <li>Email address and phone number</li>
                  <li>Subject of the request (access, correction, deletion, objection, etc.)</li>
                  <li>Reason and description of the request</li>
                </ul>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Application Methods</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                  <li><strong>Email:</strong> Send an email to info@cgteknoloji.com with the subject "KVKK Application."</li>
                  <li><strong>Written Application:</strong> Apply to our company address with a wet-signed petition.</li>
                </ul>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Response Time and Fee</h3>
                <p className="text-gray-700 leading-relaxed">Your application will be answered free of charge within a maximum of 30 days. If the request requires additional cost, a fee may be charged according to the tariff set by the Personal Data Protection Authority.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Identity Verification</h3>
                <p className="text-gray-700 leading-relaxed">CG Teknoloji reserves the right to verify the identity of the applicant. Additional documentation (e.g., a copy of ID) may be requested for secure identity verification.</p>
              </section>
            </div>
          )}
        </div>
      </div>
      <Footer language={lang} />
    </div>
  );
};

export default VeriSorumlusuBasvuru; 